import type { ComponentProps } from 'react';
import { GoogleReCaptchaProvider as GoogleReCaptchaProviderOriginal } from 'react-google-recaptcha-v3';
import { googleReCaptchaSiteKey } from 'common/services';

type P = Omit<ComponentProps<typeof GoogleReCaptchaProviderOriginal>, 'reCaptchaKey'>;

const GoogleReCaptchaProvider = (props: P) => (
  <GoogleReCaptchaProviderOriginal reCaptchaKey={googleReCaptchaSiteKey} useEnterprise {...props} />
);

export default GoogleReCaptchaProvider;
